<div class="upt" role="list" aria-label="Progreso de carga por archivo">
  @for (it of items(); track it.id) {
    <div class="upt__row" role="listitem">
      <div class="upt__head">
        <span class="upt__name">{{ it.fileName }}</span>
        <span class="upt__meta">{{ formatSize(it.sizeBytes) }}</span>
        <span class="upt__status" [class.upt__status--error]="it.status === 'error'">
          {{ statusLabel(it.status) }}
        </span>
      </div>
      @if (it.status === 'uploading' || it.status === 'completed') {
        <div class="upt__bar" aria-hidden="true">
          <div class="upt__fill" [style.width.%]="it.progress"></div>
        </div>
      }
      @if (it.errorMessage) {
        <p class="upt__err">{{ it.errorMessage }}</p>
      }
    </div>
  }
</div>
